<form [formGroup]="presetFilterForm">
    <h2 mat-dialog-title style="text-align: center">{{ header }}</h2>
    <div style="text-align: center; font-size: medium">{{ text }}</div>
    @if (data.delete) {
        <div style="text-align: center; font-size: medium; font-weight: bold">This action cannot be undone.</div>
    } @else {
        <div style="display: flex; justify-content: center">
            <mat-form-field [floatLabel]="'always'">
                <mat-label>Filter Name</mat-label>
                <input matInput formControlName="filterName" />
                @if (presetFilterForm.controls["filterName"].hasError("required")) {
                    <mat-error>{{ "GENERAL.required" | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
    }
    <div style="text-align: center; margin-top: 10px">
        <mat-dialog-actions style="justify-content: space-between" class="p-2">
            <button mat-raised-button color="warn" style="width: 100px" [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
            <button mat-raised-button color="primary" style="width: 100px" (click)="onDialogClose()">Confirm</button>
        </mat-dialog-actions>
    </div>
</form>
